import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import MobileApp from "@/MobileApp";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Path-prefix router: /m and /m/* → Mobile PWA. Everything else → Desktop App.
const _p = window.location.pathname || "/";
const isMobileApp = _p === "/m" || _p.startsWith("/m/");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {isMobileApp ? <MobileApp /> : <App />}
    </QueryClientProvider>
  </React.StrictMode>,
);
